import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';

const styles = css`
  box-shadow: 1px 4px 6px rgba(0,0,0,.2);
  .CommunityCard {
    text-decoration: none;
    .CommunityCard_Media {
      background-size: cover;
      background-position: center;
      background-repeat:no-repeat;
      padding-top:56%;
    }
    .CommunityCard_Content {
      font:700 18px/1.2 ${typography.SansSerif};
      color:${colors.color1};
      padding:15px;
      display: flex;
      flex-flow:row nowwrap;
      justify-content: space-between;
      align-items: center;
    }
    .CommunityCard_Content-arrow {
      transform:rotate(-90deg);
      width:10px;
      height:8px;
    }
  }
`;

function CommunityCard({ community }) {
  return (
    <div className={styles}>
      <Link name="community-detail" className="CommunityCard" community={community}>
        <div className="CommunityCard_Media" style={{ backgroundImage: `url('${buildThumbnailUrl(get(community, 'logo.contentUrl'), { width: 800, height: 600 })}')` }} />
        <div className="CommunityCard_Content">
          {get(community, 'name')} <img src="/images/icon-triangle.svg" className="CommunityCard_Content-arrow" alt="arrow icon" />
        </div>
      </Link>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
};

CommunityCard.defaultProps = {
  community: PropTypes.object.isRequired,
};

export default CommunityCard;



// WEBPACK FOOTER //
// ./src/components/CommunityCard.js